import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { PouchService } from '../../services/pouch-service';

@Component({
  selector: 'user-pages',
  templateUrl: './user-pages.html',
  styleUrls: ['user-pages.scss'],
})
export class UserPagesComponent {
  @Input() pages = [];

  constructor(
    public db: PouchService,
    private router: Router,
    public navCtrl: NavController
  ) {}

  open(page) {
    this.db.showpages = false;
    if ((page.page != undefined) != undefined) {
      if (page.page == 'EntitysPage') {
        this.router.navigateByUrl('/EntitysPage', {
          state: { mode: page.mode },
        });
      } else {
        this.router.navigateByUrl(page.page);
      }
    }
  }
}
